// extracted by mini-css-extract-plugin
module.exports = {"dialog":"zfriOK65CTPsPU1EOJctN"};